const SVGLoadingCircle = '<svg class="Form__circularLoader" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke-width="3"/></svg>'

export default SVGLoadingCircle;
